import { LegalInfo } from "./LegalInfo";
import { BasicCompanyInfo } from "./BasicCompanyInfo";
import { PrincipalKYCdata } from "./PrincipalKYCdata";
import { Route, Switch } from "react-router";
import LayoutCompany from "../../Layout/LayoutCompany";
import { BeneficialOwnerData } from "./BeneficialOwnerData";
import { Wizard } from "./Wizard";
import { CompanyBankAccount } from "./CompanyBankAccount";
import { ApplicationWizard } from "./ApplicationWizard";
import { GeneralCompanyInfo } from "./GeneralCompanyInfo";

export const OnBoarding = () => {
  const ROUTE = "/onboarding";
  return (
    <LayoutCompany>
      <Switch>
        <Route
          path={`${ROUTE}/basiccompanyinfo`}
          component={BasicCompanyInfo}
        />
        <Route
          path={`${ROUTE}/wizard`}
          component={Wizard}
        />
        <Route
          path={`${ROUTE}/applicationwizard`}
          component={ApplicationWizard}
        />
        <Route
          path={`${ROUTE}/generalcompanyinfo`}
          component={GeneralCompanyInfo}
        />
        <Route
          path={`${ROUTE}/legalcompanyinfo`}
          component={LegalInfo}
        />
        <Route
          path={`${ROUTE}/companybankaccount`}
          component={CompanyBankAccount}
        />
        <Route
          path={`${ROUTE}/principalkycdata`}
          component={PrincipalKYCdata}
        />
        <Route
          exact={true}
          path={`${ROUTE}/beneficialownerdata/:id`}
          component={BeneficialOwnerData}
        />
      </Switch>
    </LayoutCompany>
  );
};
